import React, { useEffect, useRef, useState } from "react";
import styles from "./BrushTool.module.scss";
import { ReactComponent as ImagineIcon } from "../Logo-Light.svg";
import { FaPaintBrush, FaRegFileImage } from "react-icons/fa";
import { blobUrlToBlob, canvasToBlobAndAppend, captureSentryException, getBase64, getCurrentUser, getDataFromSearch, getSearch, getUserDetails, uploadImageToApp, validateUser } from "../Helpers/helpers";
import Loader from "./Loader";
import {
  apiUploadToGoogleDrive,
  downloadFile,
  getFile,
  uploadFileApi,
} from "./api";
import { GrPan, GrPowerReset } from "react-icons/gr";
import cx from "classnames";
import { toast } from "react-toastify";
import { IoIosCloudDownload, IoMdHelpCircleOutline } from "react-icons/io";
import { BiSolidShare } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import AIVideo from "../assets/magic_tool_video.mp4";
import { LuEraser } from "react-icons/lu";
import { GoCircle } from "react-icons/go";
import { Mixpanel, MxEvent } from "../Mixpanel/Mixpanel";
import { FiShare } from "react-icons/fi";
import { TOOLS } from "../Helpers/constants";

var submittedPrompt = "";
function BrushTool() {
  const productUrl = decodeURIComponent(
    window.location.search?.split("?file=")?.[1] || ""
  );

  const token = getSearch("token=")

  const [product, setProduct] = useState(
    productUrl ? { url: productUrl, name: "" } : null
  );

  const [pageLoading, setPageLoading] = useState(true);
  const [finalImage, setFinaImage] = useState();
  const [brushSize, setBrushSize] = useState(30);
  const [isDrawing, setIsDrawing] = useState(false);
  const [brushClicked, setBrushClicked] = useState(null);
  const [advanceSettings, setAdvanceSettings] = useState(null);
  const [showDownloadOption, setShowDownloadOption] = useState();
  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [cfg, setCFG] = useState(10);
  const [ss, setSS] = useState(20);
  const [seed, setseed] = useState(0);
  // const [checked, setChecked] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);

  const [prompt, setPrompt] = useState();
  const [supportingPrompt, setSupportingPrompt] = useState(
    "realistic, product photography"
  );
  const [negativePrompt, setNegativePrompt] = useState("");
  // const [isSqaure, setIsSquare] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isErasing, setIsErasing] = useState(false);
  const [scale, setScale] = useState(1);

  const isGuestUserRef = useRef(null);
  const canvasRef = useRef(null);
  const isDrawingRef = useRef(null);
  const isErasingRef = useRef(null);
  const brushSizeRef = useRef(30);
  const canvasContainerRef = useRef(null);
  const imageRef = useRef(null);
  const brushRef = useRef(null);
  const imageContaineRef = useRef(null);
  const drawingAreaRef = useRef({
    left: null,
    top: null,
    right: null,
    bottom: null,
  });

  const mainNegativePrompt =
    "(((deformed))), blurry, bad anatomy, disfigured, poorly drawn face, mutation, mutated, (extra_limb), (ugly), (poorly drawn hands), fused fingers, messy drawing, broken legs censor, censored, censor_bar, multiple breasts, (mutated hands and fingers:1.5), (long body :1.3), (mutation, poorly drawn :1.2), black-white, bad anatomy, liquid body, liquidtongue, disfigured, malformed, mutated, anatomical nonsense, text font ui, error, malformed hands, long neck, blurred, lowers, low res, bad anatomy, bad proportions, bad shadow, uncoordinated body, unnatural body, fused breasts, bad breasts, huge breasts, poorly drawn breasts, extra breasts, liquid breasts, heavy breasts, missingbreasts, huge haunch, huge thighs, huge calf, bad hands, fused hand, missing hand, disappearing arms, disappearing thigh, disappearing calf, disappearing legs, fusedears, bad ears, poorly drawn ears, extra ears, liquid ears, heavy ears, missing ears, old photo, low res, black and white, black and white filter, colorless, (((deformed))), blurry, bad anatomy, disfigured, poorly drawn face, mutation, mutated, (extra_limb), (ugly), (poorly drawn hands), fused fingers, messy drawing, broken legs censor, censored, censor_bar, multiple breasts, (mutated hands and fingers:1.5), (long body :1.3), (mutation, poorly drawn :1.2), black-white, bad anatomy, liquid body, liquid tongue, disfigured, malformed, mutated, anatomical nonsense, text font ui, error, malformed hands, long neck, blurred, lowers, low res, bad anatomy, bad proportions, bad shadow, uncoordinated body, unnatural body, fused breasts, bad breasts, huge breasts, poorly drawn breasts, extra breasts, liquid breasts, heavy breasts, missing breasts, huge haunch, huge thighs, huge calf, bad hands, fused hand, missing hand, disappearing arms, disappearing thigh, disappearing calf, disappearing legs, fused ears, bad ears, poorly drawn ears, extra ears, liquid ears, heavy ears, missing ears, old photo, low res, black and white, black and white filter, colorless, (((deformed))), blurry, bad anatomy, disfigured, poorly drawn face, mutation, mutated, (extra_limb), (ugly), (poorly drawn hands), fused fingers, messy drawing, broken legs censor, censored, censor_bar, multiple breasts, (mutated hands and fingers:1.5), (long body :1.3), (mutation, poorly drawn :1.2), black-white, bad anatomy, liquid body, liquid tongue, disfigured, malformed, mutated, anatomical nonsense, text font ui, error, malformed hands, long neck, blurred, lowers, low res, bad anatomy, bad proportions, bad shadow, uncoordinated body, unnatural body, fused breasts, bad breasts, huge breasts, poorly drawn breasts, extra breasts, liquid breasts, heavy breasts, missing breasts, huge haunch, huge thighs, huge calf, bad hands, fused hand, missing hand, disappearing arms, disappearing thigh, disappearing calf, disappearing legs, fused ears, bad ears, poorly drawn ears, extra ears, liquid ears, heavy ears, missing ears, (((deformed))), blurry, bad anatomy, disfigured, poorly drawn face, mutation, mutated, (extra_limb), (ugly), (poorly drawn hands), fused fingers, messy drawing, broken legs censor, censored, censor_bar, multiple breasts, (mutated hands and fingers:1.5), (long body :1.3), (mutation, poorly drawn :1.2), black-white, bad anatomy, liquid body, liquidtongue, disfigured, malformed, mutated, anatomical nonsense, text font ui, error, malformed hands, long neck, blurred, lowers, low res, bad anatomy, bad proportions, bad shadow, uncoordinated body, unnatural body, fused breasts, bad breasts, huge breasts, poorly drawn breasts, extra breasts, liquid breasts, heavy breasts, missingbreasts, huge haunch, huge thighs, huge calf, bad hands, fused hand, missing hand, disappearing arms, disappearing thigh, disappearing calf, disappearing legs, fusedears, bad ears, poorly drawn ears, extra ears, liquid ears, heavy ears, missing ears,";

  useEffect(() => {
    async function getUserData() {
      if (token) {
        await getUserDetails(token)
      }
      isGuestUserRef.current = (await getCurrentUser())?.isGuestUser
    }

    getUserData()
  }, [])

  const handlePrompt = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
    setPrompt(e.target.value);
  };

  const handleNegativePrompt = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
    setNegativePrompt(e.target.value);
  };

  const handleSupportingPrompt = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
    setSupportingPrompt(e.target.value);
  };

  const handleImageUpload = (e) => {
    const files = e.target.files;
    const file = files[0];

    if (file && file.type.startsWith("image/")) {
      getBase64(file, (_base64) =>
        setProduct({ name: file?.name || "ProductImage.png", url: _base64 })
      );

      Mixpanel.track({
        eventName: MxEvent.CHANGE_IMAGE,
      });
    }
    setFinaImage(null);
    clearDrawingCanvas();
    document.body.removeChild(e.target);
  };

  const handleAddImage = (isMainImage) => {
    const _file = document.createElement("input");
    _file.accept = "image/*";
    _file.type = "File";
    _file.style.display = "none";
    _file.multiple = false;
    _file.onchange = (e) => handleImageUpload(e, isMainImage);
    document.body.appendChild(_file);
    _file.click();
  };

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const event = e.changedTouches?.length ? e.changedTouches?.[0] : e;
    let { nativeEvent } = event;

    if (!nativeEvent) {
      // Get the bounding rectangle of the target element
      var rect = canvas.getBoundingClientRect();

      // Calculate the offsetX and offsetY values
      let offsetX = e.touches[0].clientX - rect.left;
      let offsetY = e.touches[0].clientY - rect.top;

      nativeEvent = { offsetX, offsetY };
    }

    const offsetX = nativeEvent.offsetX;
    const offsetY = nativeEvent.offsetY;

    const context = canvas.getContext("2d");

    context.beginPath();
    context.moveTo(offsetX, offsetY);
    setIsDrawing(true);
    isDrawingRef.current = true;
  };

  const setDrawingArea = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const pixels = imageData.data;

    drawingAreaRef.current = {
      left: null,
      top: null,
      right: null,
      bottom: null,
    };

    // Iterate through each pixel to find the extreme points
    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        const index = (y * canvas.width + x) * 4; // Each pixel occupies 4 array elements (RGBA)
        const alpha = pixels[index + 3]; // Alpha value (transparency)

        // If the pixel is not fully transparent
        if (alpha > 0) {
          // Update extreme points
          if (
            drawingAreaRef.current.left === null ||
            drawingAreaRef.current.left > x
          ) {
            if (x < 0) drawingAreaRef.current.left = 0;
            else drawingAreaRef.current.left = x;
          }
          if (
            drawingAreaRef.current.right === null ||
            drawingAreaRef.current.right < x
          )
            drawingAreaRef.current.right = x;
          if (
            drawingAreaRef.current.top === null ||
            drawingAreaRef.current.top > y
          ) {
            if (y < 0) drawingAreaRef.current.top = 0;
            else drawingAreaRef.current.top = y;
          }
          if (
            drawingAreaRef.current.bottom === null ||
            drawingAreaRef.current.bottom < y
          )
            drawingAreaRef.current.bottom = y;
        }
      }
    }
  };

  const draw = (e, isErasing) => {
    e.preventDefault();
    const canvas = canvasRef.current;
    const event = e.changedTouches?.length ? e.changedTouches?.[0] : e;
    let { nativeEvent } = event;

    if (!nativeEvent) {
      // Get the bounding rectangle of the target element
      var rect = canvas.getBoundingClientRect();

      // Calculate the offsetX and offsetY values
      let offsetX = e.touches[0].clientX - rect.left;
      let offsetY = e.touches[0].clientY - rect.top;

      nativeEvent = { offsetX, offsetY };
    }

    const offsetX = nativeEvent.offsetX;
    const offsetY = nativeEvent.offsetY;

    if (brushRef.current) {
      let left;
      let top;

      if (isErasing) {
        left = offsetX - brushSizeRef.current / 2;
        top = offsetY - brushSizeRef.current / 2;
      } else {
        left = offsetX - 4 - brushSizeRef.current / 2;
        top = offsetY - 4 - brushSizeRef.current / 2;
      }

      brushRef.current.style.top = `${top}px`;
      brushRef.current.style.left = `${left}px`;

      // if (
      //   top >= 0 &&
      //   top <= parseInt(canvas.height) - brushSizeRef.current - 4
      // ) {
      //   brushRef.current.style.top = `${top}px`;
      // }

      // if (
      //   left >= 0 &&
      //   left <= parseInt(canvas.width) - brushSizeRef.current - 2
      // )
      //   brushRef.current.style.left = `${left}px`;
    }

    if (!isDrawingRef?.current) return;

    const context = canvas.getContext("2d");

    context.lineWidth = brushSizeRef.current;
    context.lineCap = "round";
    context.lineJoin = "round";

    if (isErasing) {
      context.clearRect(
        offsetX - brushSizeRef.current / 2,
        offsetY - brushSizeRef.current / 2,
        brushSizeRef.current,
        brushSizeRef.current
      );
    } else {
      context.strokeStyle = "rgba(216, 92, 38)";
      context.lineTo(offsetX, offsetY);
      context.stroke();
    }
  };

  const stopDrawing = () => {
    if (isDrawing) {
      setIsDrawing(false);
      isDrawingRef.current = false;
      // replaceDrawedPortion();
    }
  };

  const clearDrawingCanvas = () => {
    if (canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas?.getContext("2d");
      ctx?.clearRect(0, 0, canvas.width, canvas.height);
      drawingAreaRef.current = {
        left: null,
        top: null,
        right: null,
        bottom: null,
      };
      setIsDisabled(!isDisabled);
      setIsErasing(false);
      isErasingRef.current = false;
    }
  };


  const replaceDrawedPortion = ({isErase, _seed}) => {
    const img = new Image();
    img.src = product.url;

    img.onload = function () {
      setLoading(true);
      setDrawingArea();

      if (
        drawingAreaRef.current.top === null ||
        drawingAreaRef.current.left === null ||
        drawingAreaRef.current.right === null ||
        drawingAreaRef.current.bottom === null
      ) {
        toast.warning("Please draw something on image first.", {
          closeOnClick: true,
          closeButton: false,
        });
        setLoading(false);
        return;
      }
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      const mainCanvasWidth = canvas.width;
      const mainCanvasHeight = canvas.height;

      let finalImageWidth = img.width > 2496 ? 2496 : img.width;
      let finalImageHeight = img.height > 2496 ? 2496 : img.height;

      const aspectRatio = img.width / img.height;

      if (img.width > img.height)
        finalImageHeight = finalImageWidth / aspectRatio;
      else if (img.height > img.width)
        finalImageWidth = finalImageHeight * aspectRatio;

      // Kepp quality of image
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";

      let _tempCanvas = document.getElementById("imagienAICanvas2");

      if (!_tempCanvas) {
        _tempCanvas = document.createElement("canvas");
        _tempCanvas.id = "imagienAICanvas2";
      }

      const tempCtx = _tempCanvas.getContext("2d");

      // Kepp quality of image
      tempCtx.imageSmoothingEnabled = true;
      tempCtx.imageSmoothingQuality = "high";

      // Get difference between main image and drawing canvas
      const offsetWidth = finalImageWidth / mainCanvasWidth;
      const offsetHeight = finalImageHeight / mainCanvasHeight;

      //  Get brush strokes in canvas
      let { left, top, right, bottom } = drawingAreaRef.current;

      left *= offsetWidth;
      top *= offsetHeight;
      right *= offsetWidth;
      bottom *= offsetHeight;

      const width = right - left;
      const height = bottom - top;
      const center = {
        x: parseInt(left + (right - left) / 2),
        y: parseInt(top + (bottom - top) / 2),
      };

      let maskWidth = parseInt(
        Math.ceil((width + brushSizeRef.current * offsetWidth) / 8 + 5) * 8
      );

      // Set minimum to 96
      maskWidth = maskWidth < 96 ? 96 : maskWidth;
      if (maskWidth > finalImageWidth) {
        maskWidth = Math.floor(finalImageWidth / 8) * 8;
      }

      let maskHeight = parseInt(
        Math.ceil((height + brushSizeRef.current * offsetHeight) / 8 + 5) * 8
      );

      // Set minimum to 96
      maskHeight = maskHeight < 96 ? 96 : maskHeight;
      if (maskHeight > finalImageHeight) {
        maskHeight = Math.floor(finalImageHeight / 8) * 8;
      }

      // if (!checked){
      if (maskWidth < 200 && maskHeight < 200) {
        maskWidth = 200;
        maskHeight = 200;
      } else if (maskWidth < 304 && maskHeight < 304) {
        maskWidth = 304;
        maskHeight = 304;
      } else if (maskWidth < 400 && maskHeight < 400) {
        maskWidth = 400;
        maskHeight = 400;
      } else if (maskWidth < 512 && maskHeight < 512) {
        maskWidth = 512;
        maskHeight = 512;
      }
      // }
      // else {
      //   if (maskWidth < 400 && maskHeight < 400) {
      //     maskWidth = 400;
      //     maskHeight = 400;
      //   }

      //   else if (maskWidth < 512 && maskHeight < 512) {
      //     maskWidth = 512;
      //     maskHeight = 512;
      //   }
      // }

      console.log("MASK SIZE : ", maskWidth + "x" + maskHeight);

      let finalArea = {
        _left: center.x - parseInt(maskWidth / 2),
        _right: center.x + parseInt(maskWidth / 2),
        _top: center.y - parseInt(maskHeight / 2),
        _bottom: center.y + parseInt(maskHeight / 2),
      };
      //   console.log(finalArea);

      if (finalArea._left < 0) {
        finalArea._right -= finalArea._left;
        finalArea._left -= finalArea._left;
      }
      if (finalArea._right > finalImageWidth) {
        finalArea._left -= finalArea._right - finalImageWidth;

        if (finalArea._left < 0) finalArea._left = 0;
        finalArea._right -= finalArea._right - finalImageWidth;
      }

      if (finalArea._top < 0) {
        finalArea._bottom -= finalArea._top;
        finalArea._top -= finalArea._top;
      }
      if (finalArea._bottom > finalImageHeight) {
        finalArea._top -= finalArea._bottom - finalImageHeight;
        if (finalArea._top < 0) finalArea._top = 0;
        finalArea._bottom -= finalArea._bottom - finalImageHeight;
      }

      _tempCanvas.width = maskWidth;
      _tempCanvas.height = maskHeight;

      // Set the fill color (e.g., red)
      tempCtx.fillStyle = "black";

      // Fill the rectangle with the specified color
      tempCtx.fillRect(0, 0, maskWidth, maskHeight);

      const _canvas = document.createElement("canvas");
      const _ctx = _canvas.getContext("2d");

      _canvas.width = finalImageWidth;
      _canvas.height = finalImageHeight;

      _ctx.drawImage(canvas, 0, 0, finalImageWidth, finalImageHeight);

      // Get brush strokes
      const imageData = _ctx.getImageData(
        finalArea._left,
        finalArea._top,
        finalArea._right,
        finalArea._bottom
      );

      document.body.appendChild(_canvas);
      document.body.removeChild(_canvas);

      // Loop through each pixel
      for (var i = 0; i < imageData.data.length; i += 4) {
        // Extract alpha value (transparency) for the current pixel
        var alpha = imageData.data[i + 3];

        // Check if the pixel is transparent or not
        if (alpha !== 0) {
          imageData.data[i + 0] = 255;
          imageData.data[i + 1] = 255;
          imageData.data[i + 2] = 255;
          imageData.data[i + 3] = 255;
        } else {
          imageData.data[i + 0] = 0;
          imageData.data[i + 1] = 0;
          imageData.data[i + 2] = 0;
          imageData.data[i + 3] = 255;
        }
      }

      tempCtx.putImageData(imageData, 0, 0);

      canvasToBlobAndAppend(_tempCanvas).then((blob) => {
        let maskImage = blob;

        tempCtx.clearRect(0, 0, _tempCanvas.width, _tempCanvas.height);

        const _canvas = document.createElement("canvas");
        const _ctx = _canvas.getContext("2d");

        // Kepp quality of image
        _ctx.imageSmoothingEnabled = true;
        _ctx.imageSmoothingQuality = "high";

        _canvas.width = finalImageWidth;
        _canvas.height = finalImageHeight;

        _ctx.drawImage(img, 0, 0, finalImageWidth, finalImageHeight);

        // Get main image area
        const imageData = _ctx.getImageData(
          finalArea._left,
          finalArea._top,
          finalArea._right,
          finalArea._bottom
        );

        tempCtx.putImageData(imageData, 0, 0);

        document.body.appendChild(_canvas);
        document.body.removeChild(_canvas);

        canvasToBlobAndAppend(_tempCanvas).then(async (blob) => {
          const mainImage = blob;

          // const url = "https://api-brush.imagine.io/api/v1/inpaint-brush/";
          // const url = "https://api-gen-v1.imagine.io/inpaint-brush/";
          let url = "https://api-gen-v2.imagine.io/inpaint-brush/";
          const formData = new FormData();
          let headers = {}
          if (isErase){
            formData.append('image_file', mainImage)
            formData.append('mask_file', maskImage)
            formData.append('filename', "image.png")
            const _url = "https://api.magicstudio.com/magiceraser/erase"
            headers = new Headers()
            headers.append("accessToken", "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRfaWQiOiIxVmtIRTR6aXVzc2h0eWhnaFFqRUZET1l0YXk2V0lWODJ0RGFvSzVqUWFFIiwiZXhwIjoxNzU2NDcyMzk0LCJhcHBfbmFtZSI6IjE1OTk0MjgiLCJtZXRhZGF0YSI6bnVsbCwiZ3JhbnRfdHlwZSI6ImNyZWQifQ.N2cT5Kd0WTGTeEXmov8MWgrpNy3F_Oj9SAt1JAJMIW8")
            const response = await fetch(_url, {method:"POST", body:formData, headers:headers})
            const data = await response.json()
            url = data?.image_url
          }
          else{
            formData.append(
              "prompt",
              (prompt?.trim() || "") + `, ${supportingPrompt.trim() || ""}`
            );

            formData.append("cfg_inpaint", cfg);
            formData.append("seed", _seed ? _seed :seed);
            formData.append("step", ss);

            formData.append("image", mainImage);
            formData.append("mask_image", maskImage);

            formData.append(
              "negative_prompt",
              // negativePrompt || ""
              mainNegativePrompt + negativePrompt || ""
            );
          }

          document.body.appendChild(_tempCanvas);
          document.body.removeChild(_tempCanvas);

          console.log("MASK IMAGE : ", URL.createObjectURL(maskImage));
          console.log("IMAGE : ", URL.createObjectURL(mainImage));

          let _blob;

          if (isErase)
            {
              const response = await fetch(url, {method:"GET",headers:headers})
              _blob = await response.blob()
            }
          else
            _blob = await uploadFileApi(url, formData, headers);

          //   TODO:
          if (!_blob) {
            captureSentryException({failed_reason :"Unable to generate any variations, please draw another mask."})
            toast.error(
              "Unable to generate any variations, please draw another mask.",
              {
                closeOnClick: true,
                closeButton: false,
              }
            );
            setLoading(false);
            Mixpanel.track({
              eventName: MxEvent.MAGIC_TOOL_FAILED,
              properties: {
                "Mask Size": `${maskWidth} x ${maskHeight}`,
                Prompt: prompt,
                Seed: _seed ? _seed :seed,
                "Redirected from main App": Boolean(
                  product?.redirectedFromCurator
                ),
              },
            });
            return;
          }

          const _img = new Image();
          _img.src = URL.createObjectURL(_blob);
          _img.onload = function () {
            const _canvas = document.createElement("canvas");
            const _ctx = _canvas.getContext("2d");

            _canvas.width = finalImageWidth;
            _canvas.height = finalImageHeight;

            _ctx.drawImage(img, 0, 0, finalImageWidth, finalImageHeight);
            _ctx.drawImage(_img, finalArea._left, finalArea._top);

            console.log("RESPONSE : ", URL.createObjectURL(_blob));

            canvasToBlobAndAppend(_canvas).then(async (blob) => {
              getBase64(blob, async (_base64) => {
                setFinaImage(_base64);
                setLoading(false);
                Mixpanel.track({
                  eventName: MxEvent.MAGIC_TOOL_SUCCESS,
                  properties: {
                    "Mask Size": `${maskWidth} x ${maskHeight}`,
                    Prompt: prompt,
                    Seed: _seed ? _seed :seed,
                    "Redirected from main App": Boolean(
                      product?.redirectedFromCurator
                    ),
                  },
                });

                console.log("await getCurrentUser()?.", isGuestUserRef.current)


                if (!isGuestUserRef.current){
                  // region Upload Image for Main App
                  const uploadImageFormData = new FormData()
                  uploadImageFormData.append("tool_type", TOOLS.magicTool)
                  uploadImageFormData.append("input_image_url_key", product?.name || "input.png")
                  uploadImageFormData.append("input_mask_image_url_key", "maskImage.png")
                  uploadImageFormData.append("thumb_url_key", "thumbnail.png")
                  uploadImageFormData.append("output_image_url_key", `${submittedPrompt || "final-image"}.png`)
                  uploadImageFormData.append("name", `${submittedPrompt || "final-image"}`)
                  uploadImageFormData.append("seed", _seed ? _seed :seed)
                  uploadImageFormData.append("sample", ss)
                  uploadImageFormData.append("rotation", cfg)
                  uploadImageToApp({data:uploadImageFormData, input:await blobUrlToBlob(product?.blobUrl), output:blob, mask:mainImage})
                // endregion
                apiUploadToGoogleDrive({
                  blobFile: blob,
                  base64Image: _base64?.split("base64,")?.[1],
                  file_name: `${submittedPrompt || "inpaint-image"}.png`,
                  category_name: "Magic Tool",
                });
                }
              });

              document.body.appendChild(_canvas);
              document.body.removeChild(_canvas);
            });
          };
        });
      });
    };
  };

  const handleGenerateClick = () => {
    // setseed(Math.floor(Math.random() * 1000000));
    submittedPrompt = prompt;

    Mixpanel.track({
      eventName: MxEvent.CLICKED_GENERATE_MAGIC_TOOL,
      properties: {
        Prompt: prompt,
        Seed: seed,
        "Redirected from main App": Boolean(product?.redirectedFromCurator),
      },
    });
    replaceDrawedPortion({});
  };

  function generateRandomNumber(min, max) {
    // Generate a random number between min (inclusive) and max (inclusive)
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }

  const resizeCanvas = () => {
    if (window.innerWidth < 500) setIsMobile(true);
    else setIsMobile(false);
    if (!imageRef.current) return;
    const top =
      imageContaineRef.current?.getBoundingClientRect().top -
      imageRef.current?.getBoundingClientRect().top;
    const left =
      imageContaineRef.current?.getBoundingClientRect().left -
      imageRef.current?.getBoundingClientRect().left;
    const { height, width } = imageRef.current?.getBoundingClientRect();

    canvasRef.current.height = Math.ceil(height);
    canvasRef.current.width = Math.ceil(width);
    canvasContainerRef.current.style.width = `${-Math.ceil(width)}px`;
    canvasContainerRef.current.style.height = `${-Math.ceil(height)}px`;
    canvasContainerRef.current.style.top = `${-top}px`;
    canvasContainerRef.current.style.left = `${-left}px`;

    clearDrawingCanvas();
  };

  useEffect(() => {
    if (imageRef.current)
      setTimeout(() => {
        resizeCanvas();
      }, [100]);

    if (canvasRef?.current)
      canvasRef?.current?.addEventListener(
        "touchmove",
        (e) => draw(e, isErasingRef.current),
        {
          passive: false,
        }
      );

    return () =>
      canvasRef?.current?.removeEventListener("touchmove", (e) =>
        draw(e, isErasingRef?.current)
      );
  }, [product?.url, imageRef.current]);

  const getRenderFile = async () => {
    const renderFile = getDataFromSearch()?.renderFile;

    if (renderFile) {
      setLoading(true);
      const image = await getFile(renderFile);

      if (image) {
        try {
          getBase64(image, (base64) => {
            setProduct({
              url: base64,
              name: "image.png",
              redirectedFromCurator: true,
            });
            setLoading(false);
          });
        } catch (error) {
          setLoading(false);
          captureSentryException({failed_reason : error})
        }
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("alreadyVisitedMagicTool") && !pageLoading) {
      // setShowVideo(true);
      localStorage.setItem("alreadyVisitedMagicTool", true);
    }
  }, [pageLoading]);

  useEffect(() => {
    validateUser(setPageLoading);

    getRenderFile();

    window.addEventListener("resize", () =>
      setTimeout(() => {
        resizeCanvas();
      }, [100])
    );
    window.addEventListener("click", () => {
      setBrushClicked(false);
      setAdvanceSettings(false);
      setShowVideo(false);
      setShowDownloadOption(false);
    });

    window.addEventListener("mouseup", () => {
      setIsDrawing(false);
      isDrawingRef.current = false;
    });

    window.history.pushState(null, "", `${window.location.pathname}`);

    return () => {
      window.removeEventListener("resize", () =>
        setTimeout(() => {
          resizeCanvas();
        }, [100])
      );
      window.removeEventListener("click", () => {
        setBrushClicked(false);
        setAdvanceSettings(false);
        setShowVideo(false);
        setShowDownloadOption(false);
      });

      window.removeEventListener("mouseup", () => {
        setIsDrawing(false);
        isDrawingRef.current = false;
      });
    };
  }, []);

  const handleDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDownloadOption(!showDownloadOption);
    Mixpanel.track({
      eventName: MxEvent.CLICKED_MAGIC_TOOL_IMAGE_DOWNLOAD,
    });
  };

  const downloadOriginal = () => {
    downloadFile(
      finalImage,
      product?.name ? `AI ${product.name}` : "AIImage.png"
    );

    Mixpanel.track({
      eventName: MxEvent.DOWNLOAD_MAGIC_TOOL_STANDARD_IMAGE,
      properties: {
        Prompt: prompt,
      },
    });
  };

  const downloadUpscaledImage = async (_value) => {
    await fetch(finalImage)
      .then(async (response) => await response.blob())
      .then(async (__blob) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("image", __blob);
        formData.append("value", _value);

        // const upscaleUrl = "https://api-upscale.imagine.io/api/v1/upscaler/"; // bsr-gan
        const upscaleUrl = "https://api-enhance.imagine.io/upscaler/"; // bsr-gan
        const _blob = await uploadFileApi(upscaleUrl, formData);
        if (_blob) {
          const imageUrl = URL.createObjectURL(_blob);
          downloadFile(
            imageUrl,
            product?.name ? `AI ${product.name}` : `AIImage.png`
          );

          Mixpanel.track({
            eventName: MxEvent.DOWNLOAD_MAGIC_TOOL_UPSCALED_IMAGE,
            properties: {
              Prompt: prompt,
            },
          });

          if (!isGuestUserRef.current){
            // region Upload Image for Main App
             const uploadImageFormData = new FormData()
             uploadImageFormData.append("tool_type", TOOLS.magicTool)
             uploadImageFormData.append("output_image_url_key", `${prompt}.png` || "final-image.png")
             uploadImageFormData.append("thumb_url_key", "thumbnail.png")
             uploadImageFormData.append("name", prompt)
             uploadImageFormData.append("upscaled", 1)
             uploadImageToApp({ data: uploadImageFormData, output: _blob })
  
           getBase64(_blob, (_base64) => {
             apiUploadToGoogleDrive({
               blobFile: _blob,
               base64Image: _base64?.split("base64,")?.[1],
               file_name: `${submittedPrompt || "upscaled-image"}.png`,
               category_name: "Upscaled Magic Tool",
             });
           });
          }

        }
        setLoading(false);
      });
  };

  const handleReizeImage = (zoomOut) => {
    if (zoomOut) {
      const _scale = scale - 0.5;
      if (_scale < 1) setScale(1);
      else setScale(_scale);
    } else {
      const _scale = scale + 0.5;
      if (_scale > 5) setScale(5);
      else setScale(_scale);
    }
  };

  return (
    <>
      <Loader loading={pageLoading} backgroundColor="#fff" />
      <div className="App">
        <div className={styles.brushToolContainer}>
          <div className={styles.header}>
            <a href="https://imagine.io/">
              <ImagineIcon className={`logo`} />
            </a>
            <div
              className={`help ${styles.help}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowVideo(true);
              }}
            >
              <IoMdHelpCircleOutline />
              <div className={`tooltip ${styles.tooltip}`}>Help</div>
            </div>
          </div>

          <div className={styles.imageContainer}>
            <div className={styles.image} ref={imageContaineRef}>
              <div className={styles.controlButton}>
                <div
                  className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                  onClick={(e) => {
                    setBrushClicked(!brushClicked);
                    e.stopPropagation();
                    Mixpanel.track({
                      eventName: MxEvent.CLICKED_TOOL_SIZE_BUTTON,
                    });
                  }}
                >
                  <GoCircle />{" "}
                  <div className={styles.useImageTooltip}>Tool size</div>
                  <div
                    className="scale-slider"
                    style={{ width: "100%" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      className={cx(
                        styles.brushSizeSettings,
                        brushClicked && product?.url ? styles.open : ""
                      )}
                    >
                      <div className="scale-slider-container">
                        <div className="scale-info">
                          <h5 style={{ fontWeight: 400 }}>Tool Size</h5>
                        </div>

                        <input
                          type="range"
                          step={1}
                          max={100}
                          min={1}
                          value={brushSize}
                          onChange={(e) => {
                            setBrushSize(e.target.value);
                            brushSizeRef.current = e.target.value;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                  // style={
                  //   isErasing
                  //     ? { background: "#d85c26", border: "1px solid #d85c26" }
                  //     : {}
                  // }
                  onClick={() => {
                    isErasingRef.current = !isErasing;
                    Mixpanel.track({
                      eventName: !isErasing
                        ? MxEvent.CLICKED_ERASER_BUTTON
                        : MxEvent.CLICKED_BRUSH_BUTTON,
                    });
                    setIsErasing(!isErasing);
                  }}
                >
                  {!isErasing ? <LuEraser /> : <FaPaintBrush />}
                  <div className={styles.useImageTooltip}>
                    {!isErasing ? "Eraser" : "Brush"}
                  </div>
                </div>

                <div
                  className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                  onClick={() => {
                    clearDrawingCanvas();
                    Mixpanel.track({
                      eventName: MxEvent.CLICKED_RESET_BUTTON,
                    });
                  }}
                >
                  <GrPowerReset />
                  <div className={styles.useImageTooltip}>Clear</div>
                </div>
                <div
                  className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                  onClick={handleAddImage}
                >
                  <FaRegFileImage />
                  <div className={styles.useImageTooltip}>Upload image</div>
                </div>
              </div>
              {product?.url ? (
                <>
                  {/* <div className={styles.bottomControlButton}>
                  <div
                    className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                    onClick={() => setIsErasing(!isErasing)}
                  >
                    <GrPan />
                    <div className={styles.useImageTooltip}>Pan</div>
                  </div>

                  <div
                    className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                    onClick={handleReizeImage}
                  >
                    <MdOutlineZoomIn />
                    <div className={styles.useImageTooltip}>Zoom In</div>
                  </div>
                  <div
                    className={`btn normal-btn btn-hover position-relative ${styles.useImage}`}
                    onClick={() => handleReizeImage(true)}
                  >
                    <MdOutlineZoomOut />
                    <div className={styles.useImageTooltip}>Zoom out</div>
                  </div>
                </div> */}
                  <img
                    ref={imageRef}
                    style={{ transform: `scale(${scale})` }}
                    src={product?.url}
                    alt={product?.name || ""}
                  />{" "}
                  <div
                    className={styles.canvasContainer}
                    ref={canvasContainerRef}
                  >
                    <canvas
                      ref={canvasRef}
                      onMouseDown={startDrawing}
                      onMouseMove={(e) => draw(e, isErasing)}
                      onTouchStart={startDrawing}
                      // onTouchMove={draw}
                      onTouchEnd={() => {
                        setIsDrawing(false);
                        isDrawingRef.current = false;
                      }}
                      onMouseUp={() => {
                        setIsDrawing(false);
                        isDrawingRef.current = false;
                      }}
                      // onMouseOut={() => {
                      //   setIsDrawing(false);
                      //   isDrawingRef.current = false;
                      // }}
                      style={{
                        //   height: `${Math.min(getMaxDim().y, resolution.y)}px`,
                        //   width: `${Math.min(getMaxDim().x, resolution.x)}px`,
                        //   maxWidth: `${Math.min(getMaxDim().x, resolution.x)}px`,
                        //   maxHeight: `${Math.min(getMaxDim().y, resolution.y)}px`,
                        //   position: "absolute",
                        top: `0px`,
                        left: `0px`,
                        objectFit: "contain",
                        userSelect: "none",
                        display: "block",
                        transition: "transform 0.1s ease-in-out",
                        cursor: brushSize ? "none" : "default",
                        opacity: 0.5,
                        zIndex: 100000,
                      }}
                      // width={Math.min(getMaxDim().x, resolution.x)} // Set width of canvas
                      // height={Math.min(getMaxDim().y, resolution.y)} // Set height of canvas
                    />
                    {/* Brush Pointer */}
                    <div
                      ref={brushRef}
                      style={{
                        position: "absolute",
                        pointerEvents: "none",
                        height: `${brushSize}px`,
                        width: `${brushSize}px`,
                        borderRadius: isErasing ? "0" : "50%",
                        border: isErasing
                          ? "1px solid #EAEAEA"
                          : "2px solid #d85c26",
                        background: isErasing ? "#EAEAEA50" : "#d85c2650",
                      }}
                    ></div>
                  </div>
                </>
              ) : (
                <div className={styles.uploadImage} onClick={handleAddImage}>
                  Click to upload image
                </div>
              )}
            </div>
            <div
              className={cx(
                styles.image,
                styles.finalImageContainer,
                isMobile && !finalImage ? styles.hidden : ""
              )}
            >
              {finalImage ? (
                <>
                  <img src={finalImage} alt={""} />{" "}
                  <div className={styles.controlButton}>
                    <div
                      className={`btn btn-hover normal-btn position-relative ${styles.useImage}`}
                      onClick={() => {
                        setProduct({ name: "", url: finalImage });
                        clearDrawingCanvas();
                        Mixpanel.track({
                          eventName: MxEvent.CLICKED_USE_GENERATED_IMAGE,
                        });
                        if (isMobile) setFinaImage(null);
                      }}
                    >
                      {isMobile ? <FiShare /> : <BiSolidShare />}

                      <div className={styles.useImageTooltip}>
                        Use this image
                      </div>
                    </div>

                    <div
                      className={`btn btn-hover normal-btn position-relative ${styles.useImage}`}
                      onClick={handleDownload}
                    >
                      <IoIosCloudDownload />
                      <div className={styles.useImageTooltip}>Download</div>
                      <div
                        className={`download-options ${
                          showDownloadOption ? "show-download-options" : ""
                        }`}
                      >
                        <div
                          className="download-options-item"
                          onClick={downloadOriginal}
                        >
                          Standard
                        </div>

                        <div className="separator"></div>
                        <div
                          className="download-options-item"
                          onClick={() => downloadUpscaledImage(2)}
                        >
                          High Resolution
                        </div>

                        {/* <div className="separator"></div>
                          <div
                            className="download-options-item"
                            onClick={() => downloadUpscaledImage(4)}
                          >
                            Upscale 4X
                          </div> */}
                      </div>
                    </div>

                    <div
                      className={`btn btn-hover normal-btn position-relative ${styles.useImage}`}
                      onClick={() => {
                        setFinaImage(null);
                        Mixpanel.track({
                          eventName: MxEvent.CLICKED_CLOSE_GENERATED_IMAGE,
                        });
                      }}
                    >
                      <IoMdClose />

                      <div className={styles.useImageTooltip}>Close</div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <div className={styles.promptArea}>
            <div className={styles.prompts}>
              <div className={styles.prompt}>
                <div className="title" style={{ paddingBottom: "0.5rem" }}>
                  Prompt
                </div>
                <textarea
                  type="text-area"
                  cols={4}
                  rows={5}
                  onInput={handlePrompt}
                  placeholder="Enter your prompt"
                  data-hj-allow
                ></textarea>
              </div>

              {!isMobile ? (
                <>
                  {/* <div className={styles.prompt}>
                  <div className="title" style={{ paddingBottom: "0.5rem" }}>
                    Negative Prompt
                  </div>
                  <textarea
                    type="text-area"
                    cols={4}
                    rows={5}
                    value={negativePrompt}
                    onInput={handleNegativePrompt}
                    placeholder="Add aspects to exclude from background"
                    data-hj-allow
                  ></textarea>
                </div> */}

                  {/* <div className={styles.prompt}>
                  <div className="title" style={{ paddingBottom: "0.5rem" }}>
                    Supporting Prompt
                  </div>
                  <textarea
                    type="text-area"
                    cols={4}
                    rows={2}
                    value={supportingPrompt}
                    onInput={handleSupportingPrompt}
                    data-hj-allow
                  ></textarea>
                </div> */}
                </>
              ) : null}
            </div>
            <div className={`${styles.promptButton}`}>
              <div className="w-100" style={{display: "flex", gap:"0.5rem", alignItems:"center"}}>
                {/* <div className={`btn normal-btn align-center`} style={{height: "2rem"}} onClick={() => replaceDrawedPortion({isErase: true})}>Erase</div> */}
                <div
                  className={`${cx(
                    styles.generateBtn,
                    // isMobile ? styles.full : ""
                  )} btn generate-btn ${
                    product?.url && prompt ? "" : "disabled"
                  }
                  ${isMobile ? styles.full: ""}
                  `}
                  onClick={handleGenerateClick}
                  style={{height: "auto", width: "80%"}}
                >
                  Generate
                </div>
              </div>
              {/* <div
                    className="scale-slider"
                    style={{ width: "100%" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      className="scale-slider-container"
                      style={{ paddingBottom: "1rem" }}
                    >
                      <div className="scale-info">
                        <h5 style={{ fontWeight: 400 }}>Sampling steps</h5>
                        <input
                          type="text"
                          value={ss}
                          style={{ pointerEvents: "none", userSelect: "none" }}
                        />
                      </div>

                      <input
                        type="range"
                        step={5}
                        max={50}
                        min={5}
                        value={ss}
                        onChange={(e) => {
                          setSS(e.target.value);
                        }}
                      />
                    </div>
                  </div>

              {/* <div className="negative-prompt">
                <span>Above 400x400</span>
                <div className="toggle-container">
                  <label className="toggle">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => setChecked(!checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div> */}

              {/*<div
              className={`${cx(
                styles.generateBtn,
                isMobile ? styles.full : ""
              )} btn generate-btn`}
              onClick={() => setIsSquare(!isSqaure)}
            >
              Square Mask:  {isSqaure.toString()}
            </div> */}

              {/* ADVANCE SETTINGS */}
              {/* <div
              className={`btn normal-btn ${styles.full}`}
              style={{ position: "relative" }}
              onClick={(e) => {
                e.stopPropagation();
                setAdvanceSettings(!advanceSettings);
              }}
            >
              Advance Settings
              <div
                className="scale-slider"
                style={{ width: "100%" }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  className={cx(
                    styles.advanceSettings,
                    advanceSettings ? styles.open : ""
                  )}
                >
                  <div
                    className="scale-slider-container"
                    style={{ paddingBottom: "1rem" }}
                  >
                    <div className="scale-info">
                      <h5 style={{ fontWeight: 400 }}>CFG - inpaint</h5>
                      <input
                        type="text"
                        value={cfg}
                        style={{ pointerEvents: "none", userSelect: "none" }}
                      />
                    </div>

                    <input
                      type="range"
                      step={0.1}
                      max={10}
                      min={0}
                      value={cfg}
                      onChange={(e) => setCFG(e.target.value)}
                    />
                  </div>

                  <div
                    className="scale-slider"
                    style={{ width: "100%" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      className="scale-slider-container"
                      style={{ paddingBottom: "1rem" }}
                    >
                      <div className="scale-info">
                        <h5 style={{ fontWeight: 400 }}>Sampling steps</h5>
                        <input
                          type="text"
                          value={ss}
                          style={{ pointerEvents: "none", userSelect: "none" }}
                        />
                      </div>

                      <input
                        type="range"
                        step={1}
                        max={200}
                        min={1}
                        value={ss}
                        onChange={(e) => {
                          setSS(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div
              className={`btn normal-btn ${prompt?.trim() ? "" : "disabled"} ${isMobile ? "w-95" : "w-90"}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.35rem",
                justifyContent: "center",
              }}
              onClick={() => {
                const _seed = generateRandomNumber(0, 10000000)
                setseed(_seed)
                if (prompt?.trim())
                  replaceDrawedPortion({_seed:_seed})
              }}
            >
              <GrPowerReset
                style={{
                  cursor: "pointer",
                  color: "#ffffff",
                  fontWeight: "bold",
                }}
              />
              Shuffle
            </div>

              {/* <div
                className="scale-slider-container"
                style={{
                  marginBottom: !isMobile ? "1rem" : 0,
                  width: isMobile ? "95%" : "auto",
                }}
              >
                <div className="scale-info">
                  <h5
                    style={{
                      fontWeight: 500,
                      color: "#ffffff",
                      paddingRight: "0.5rem",
                    }}
                  >
                    Shuffle
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      width: "80%",
                      marginTop: "0.5rem",
                    }}
                  >
                    <input
                      type="number"
                      value={seed}
                      onChange={(e) => {
                        setseed(e.target.value || 0);
                      }}
                      style={{ userSelect: "none", width: "100%" }}
                    />
                    <GrPowerReset
                      style={{
                        cursor: "pointer",
                        margin: "auto",
                        color: "#ffffff",
                        fontWeight: "bold",
                      }}
                      onClick={() => {
                        setseed(Math.floor(Math.random() * 1000000));
                      }}
                    />
                  </div>
                </div>
              </div> */}
              {/* <Select
              defaultValue={customResolutions[0]}
              options={customResolutions}
              onChange={() => {}}
              isReadOnly
              isSearchable={false}
              className="resolution-select"
              menuPosition="absolute"
              menuPlacement="top"
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  cursor: "pointer",
                }),
                option: (provided, state) => ({
                  ...provided,
                  cursor: "pointer",
                  color: state.isFocused ? "black" : "inherit",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "inherit",
                  "&:hover, &:active": {
                    color: "#ffffff", // Change font color on hover
                    backgroundColor: "#d85c26", // Change background color on hover
                  },
                }),
                input: (provided, state) => ({
                  ...provided,
                  opacity: 0,
                }),
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 4,
                colors: {
                  ...theme.colors,
                  neutral5: "black",
                  primary25: "white",
                  primary: "white",
                },
              })}
            /> */}
            </div>

            {/* {isMobile ? (
            <div className={styles.promptArea}>
              <div className={styles.prompts}>
                <div className={styles.prompt}>
                  <div className="title" style={{ paddingBottom: "0.5rem" }}>
                    Negative Prompt
                  </div>
                  <textarea
                    type="text-area"
                    cols={4}
                    rows={5}
                    value={negativePrompt}
                    onInput={handleNegativePrompt}
                    placeholder="Add aspects to exclude from background"
                    data-hj-allow
                  ></textarea>
                </div>
              </div>
            </div>
          ) : null} */}
          </div>
        </div>

        <Loader loading={loading} />

        {showVideo ? (
          <div className="ai-video-player">
            <div
              className="video-container"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <video
                id="ai-video-player"
                loop
                controls
                autoPlay
                playsInline
                controlsList="nodownload"
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
              >
                <source src={AIVideo} type="video/mp4" />
              </video>
              <div className="closeIcon" onClick={() => setShowVideo(false)}>
                <IoMdClose />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default BrushTool;
